import {Consultation} from './consultation';

export class RendezVous {
	rendez_vous_id : number;
	rendez_vous_date:Date;
	str_rendez_vous_date : any;
	rendez_vous_heure:any;
	rendez_vous_motif:any;
	motif_repos:any;
	consultation:Consultation;
	id_consultation : number;
	id_employer : number;
	id_agent : number;
	constructor(){
		this.rendez_vous_id=null;
			
	}

}
